/* eslint-disable quotes */
import React, { Component } from "react";
/* eslint-disable */
import { Button, Col, Form, Input, Row, Select, Switch } from "antd";

const { Option } = Select;
const FormItem = Form.Item;

//! RFID change

const cartridgeMapRFID = {
  1: "E0CCBE9C0E",
  2: "A06E10E937",
  3: "B0FA0DE9AE", //new
  4: "70D30DE947",
  5: "D0F20BE9C0",
  6: "30AC0DE978",
  7: "60110DE995",
  8: "20810BE943",
  9: "F0210EE936",
  10: "F0180CE90D",
  11: "000111E9F9", //new
  12: "50780CE9CD",
  13: "A03610E96F",
  14: "103F0CE9CA",
  15: "F0840DE990",
  16: "F05B10E952",
  17: "D0F011E9D8",
  18: "70360DE9A2",
  19: "602611E9BE",
  20: "00A70BE945",
  21: "80360BE954",
  22: "62B643DC4B",
  23: "429E43DC43",
  24: "227642DCCA",
  25: "325643DCFB",
  26: "D27442DC38",
  27: "424F45DC94",
  28: "30BA11E972",
  29: "62EF42DC13",
  30: "122244DCA8",
  31: "020644DC9C",
  32: "72B242DC5E",
  33: "92ED42DCE1",
  34: "302213E9E8",
  35: "700213E988",
  36: "024243DCDF", //new
  37: "92FA42DCF6",
  38: "02CB45DC50",
  39: "62B242DC4E",
  40: "920FDC0849", //new
  41: "60C012E95B",
  42: "D27149DC36",
  43: "F29A49DCFD",
  44: "C09E12E9A5",
  45: "92E548DCE3",
  46: "9283DC8548", //new
  47: "904B11E923",
  48: "A25A48DC6C",
  49: "A07011E928",
  50: "12FD47DC74",
  51: "9257DC5148", //new
  52: "B0E112E9AA",
  53: "727B47DC92",
  54: "B05D0DE909",
  55: "30110BE9C3", //new
  56: "10DC10E935",
  57: "25347DCCA0",
  58: "F2D747DCBE",
  59: "E2FD49DC8A",
  60: "C0B810E981",
  61: "E01412E90F",
  62: "F03712E93C",
  63: "C05A12E961",
  64: "809511E9ED",
  65: "C09310AAE9", //new
  66: "30D80CE90D",
  67: "607D12E9E6",
  68: "E22C4ADC58",
  69: "301110E9D8",
  70: "C2F949DCAE",
  71: "D09919E9B9",
  72: "E0CB1FE9DD",
  73: "E05D19E94D",
  74: "10BD1EE95A",
  75: "F0F21AE9F1",
  76: "70831EE904",
  77: "60081FE99E",
  78: "F0361EE931",
  79: "B0B11DE9F5",
  80: "40921B20E9",
  81: "D02119E901",
  82: "20D619E906",
  83: "00601CE995",
  84: "205D1EE98A",
  85: "E0271BE935",
  86: "F0CF1AE9CC",
  87: "20EF1BE93D",
  88: "B0571AE914", //new
  89: "60E31CE976",
  90: "00BE1CE94B",
  91: "20531DE987",
  92: "40B71BE905",
  93: "D08B1DE9AF",
  94: "70B719E937",
  95: "70791AE9FA",
  96: "D0081DE92C",
  97: "D09B1AE9B8", //new
  98: "20561FE980",
  99: "70E31EE964",
  100: "B0961EE9D1",
  101: "404B1BE9F9",
  102: "A0D71DE983",
  103: "607D1FE9EB",
  104: "F0651DE961",
  105: "004019E9B0",
  106: "706D1BE9EF",
  107: "802D1DE959",
  108: "10E518E904",
  109: "A0141CE941",
  110: "800319E973",
  111: "50361AE995",
  112: "50F519E955",
  113: "E0851CE990",
  114: "70BE1AE93D",
  115: "D0101EE937",
  116: "A0A41FE9F2",
  117: "32ABDEF6B1",
  118: "62B2DEF6F8",
  119: "229CDEF696",
  120: "B2ACDEF636",
  121: "3296DEF68C",
  122: "E2B3DEF679",
  123: "52A4DEF6DE", //new
  124: "82B3DEF619",
  125: "62ABDEF6E1",
  126: "52ACDEF6D6",
  127: "E2A4DEF66E",
  128: "D2BCDEF646",
  129: "92A3F619DE",
  130: "A2C0DEF64A",
  131: "C29BDEF671",
  132: "82A4DEF60E",
  133: "F2A3DEF679",
  134: "52B3DEF6C9",
  135: "429ADEF6F0",
  136: "82ACDEF606",
  137: "22B3DEF6B9",
  138: "52AADEF6D0",
  139: "F29BDEF641",
  140: "B29CDEF606",
  141: "C2ABDEF641",
  142: "62BBDEF6F1",
  143: "02A3DEF689",
  144: "8299DEF633",
  145: "929BF621DE",
  146: "C2B9DEF653",
  147: "1277DEF64D",
  148: "62A3DEF6E9",
  149: "12B4DEF68E",
  150: "52A9DEF6D3",
  151: "92BBF601DE",
  152: "92C4F67EDE",
  153: "22A9DEF6A3",
  154: "F2BBDEF661",
  155: "5299DEF6E3",
  156: "C296DEF67C",
  157: "E2A2DEF668",
  158: "A2B4DEF63E",
  159: "5295DEF6EF",
  160: "F2B9DEF663",
  161: "D2B4DEF64E",
  162: "829CDEF636",
  163: "52BCDEF6C6",
  164: "82BCDEF616",
  165: "22BCDEF6B6",
  166: "32B9DEF6A3",
  167: "22BADEF6B0",
  168: "22A4DEF6AE",
  169: "B2BADEF620",
  170: "62C4DEF68E",
  171: "C2BBDEF651",
  172: "92ABF611DE",
  173: "0270DBF65F", //new
  174: "F294DEF64E",
  175: "72A1DEF6FB",
  176: "6278DEF632",
  177: "32BBDEF6A1",
  178: "02BBDEF691",
  179: "02B2DEF698",
  180: "329BDEF681",
  181: "8295DEF63F",
  182: "22AADEF6A0",
  183: "E276DEF6BC",
  184: "2299DEF693",
  185: "A29ADEF610",
  186: "C2A9DEF643",
  187: "D27EDEF684",
  188: "C2C4DEF62E",
  189: "B276DEF6EC",
  190: "0278DEF652",
  191: "C294DEF67E",
  192: "8276DEF6DC",
  193: "C2B2DEF658",
  194: "F2A9DEF673",
  195: "3278DEF662",
  196: "729ADEF6C0", //new
  197: "42B4DEF6DE",
  198: "B2A4DEF63E",
  199: "22ACDEF6A6",
  200: "129BDEF6A1",
  201: "32A3DEF6B9",
  202: "529CDEF6E6",
  203: "D295DEF66F",
  204: "E2ACDEF666",
  205: "72B4DEF6EE",
  206: "02ABDEF681",
  207: "C2A3DEF649",
  208: "F2ABDEF671",
  209: "E2BADEF670",
  210: "A26FDEF6E5",
  211: "6270DEF63A",
  212: "92B9F603DE",
  213: "E26EDEF6A4",
  214: "92B2F608DE",
  215: "C26EDEF684",
  216: "B295DEF60F",
  217: "F2A1DEF67B",
  218: "027FDEF655",
  219: "129ADEF6A0",
  220: "927FF6C5DE",
  221: "327FDEF665",
  222: "12A1DEF69B",
  223: "B2A2DEF638",
  224: "82BADEF610",
  225: "12B1DEF68B",
  226: "426FDEF605",
  227: "B2B3DEF629",
  228: "9296F62CDE",
  229: "B299DEF603",
  230: "629BDEF6D1",
  231: "A27EDEF6F4",
  232: "4277DEF61D",
  233: "3270DEF66A",
  234: "726FDEF635",
  235: "A277DEF6FD",
  236: "B2AADEF630",
  237: "D2B1DEF64B", //new
  238: "52BADEF6C0",
  239: "A2B1DEF63B",
  240: "22A2DEF6A8",
  241: "E2AADEF660",
  242: "9268F6D2DE",
  243: "0270DEF65A",
  244: "32B2DEF6A8",
  245: "7277DEF62D",
  246: "126FDEF655",
  247: "62C2DEF688",
  248: "02B9DEF693",
  249: "627FDEF635",
  250: "82A9DEF603",
  251: "92C2F678DE",
  252: "C2C2DEF628",
  253: "62B9DEF6F3",
  254: "D26FDEF695",
  255: "0296DEF6BC",
  256: "82A2DEF608",
  257: "6296DEF6DC",
  258: "52A2DEF6D8",
  259: "42B1DEF6DB",
  260: "72B1DEF6EB",
  261: "82AADEF600",
  262: "92A1F61BDE",
  263: "42A1DEF6CB",
  264: "6268DEF622",
  265: "3268DEF672",
  266: "D277DEF68D",
  267: "F2B2DEF668",
  268: "E299DEF653",
  269: "C2A1DEF64B",
  270: "C29ADEF670",
};
const cartridgeMap = {
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  10: "10",
  11: "11",
  12: "12",
  13: "13",
  14: "14",
  15: "15",
  16: "16",
  17: "17",
  18: "18",
  19: "19",
  20: "20",
};
const cartridgeMapRevRFID = {
  E0CCBE9C0E: "1",
  A06E10E937: "2",
  B0FA0DE9AE: "3", //new
  "70D30DE947": "4",
  D0F20BE9C0: "5",
  "30AC0DE978": "6",
  "60110DE995": "7",
  "20810BE943": "8",
  F0210EE936: "9",
  F0180CE90D: "10",
  "000111E9F9": "11", //new
  "50780CE9CD": "12",
  A03610E96F: "13",
  "103F0CE9CA": "14",
  F0840DE990: "15",
  F05B10E952: "16",
  D0F011E9D8: "17",
  "70360DE9A2": "18",
  "602611E9BE": "19",
  "00A70BE945": "20",
  "80360BE954": "21",
  "62B643DC4B": "22",
  "429E43DC43": "23",
  "227642DCCA": "24",
  "325643DCFB": "25",
  D27442DC38: "26",
  "424F45DC94": "27",
  "30BA11E972": "28",
  "62EF42DC13": "29",
  "122244DCA8": "30",
  "020644DC9C": "31",
  "72B242DC5E": "32",
  "92ED42DCE1": "33",
  "302213E9E8": "34",
  "700213E988": "35",
  "024243DCDF": "36", //new
  "92FA42DCF6": "37",
  "02CB45DC50": "38",
  "62B242DC4E": "39",
  "920FDC0849": "40", //new
  "60C012E95B": "41",
  D27149DC36: "42",
  F29A49DCFD: "43",
  C09E12E9A5: "44",
  "92E548DCE3": "45",
  "9283DC8548": "46", //new
  "904B11E923": "47",
  A25A48DC6C: "48",
  A07011E928: "49",
  "12FD47DC74": "50",
  "9257DC5148": "51", //new
  B0E112E9AA: "52",
  "727B47DC92": "53",
  B05D0DE909: "54",
  "30110BE9C3": "55", //new
  "10DC10E935": "56",
  "25347DCCA0": "57",
  F2D747DCBE: "58",
  E2FD49DC8A: "59",
  C0B810E981: "60",
  E01412E90F: "61",
  F03712E93C: "62",
  C05A12E961: "63",
  "809511E9ED": "64",
  C09310AAE9: "65", //new
  "30D80CE90D": "66",
  "607D12E9E6": "67",
  E22C4ADC58: "68",
  "301110E9D8": "69",
  C2F949DCAE: "70",
  D09919E9B9: "71",
  E0CB1FE9DD: "72",
  E05D19E94D: "73",
  "10BD1EE95A": "74",
  F0F21AE9F1: "75",
  "70831EE904": "76",
  "60081FE99E": "77",
  F0361EE931: "78",
  B0B11DE9F5: "79",
  "40921B20E9": "80",
  D02119E901: "81",
  "20D619E906": "82",
  "00601CE995": "83",
  "205D1EE98A": "84",
  E0271BE935: "85",
  F0CF1AE9CC: "86",
  "20EF1BE93D": "87",
  B0571AE914: "88", //new
  "60E31CE976": "89",
  "00BE1CE94B": "90",
  "20531DE987": "91",
  "40B71BE905": "92",
  D08B1DE9AF: "93",
  "70B719E937": "94",
  "70791AE9FA": "95",
  D0081DE92C: "96",
  D09B1AE9B8: "97", //new
  "20561FE980": "98",
  "70E31EE964": "99",
  B0961EE9D1: "100",
  "404B1BE9F9": "101",
  A0D71DE983: "102",
  "607D1FE9EB": "103",
  F0651DE961: "104",
  "004019E9B0": "105",
  "706D1BE9EF": "106",
  "802D1DE959": "107",
  "10E518E904": "108",
  A0141CE941: "109",
  "800319E973": "110",
  "50361AE995": "111",
  "50F519E955": "112",
  E0851CE990: "113",
  "70BE1AE93D": "114",
  D0101EE937: "115",
  A0A41FE9F2: "116",
  "32ABDEF6B1": "117",
  "62B2DEF6F8": "118",
  "229CDEF696": "119",
  B2ACDEF636: "120",
  "3296DEF68C": "121",
  E2B3DEF679: "122",
  "52A4DEF6DE": "123", // new
  "82B3DEF619": "124",
  "62ABDEF6E1": "125",
  "52ACDEF6D6": "126",
  E2A4DEF66E: "127",
  D2BCDEF646: "128",
  "92A3F619DE": "129",
  A2C0DEF64A: "130",
  C29BDEF671: "131",
  "82A4DEF60E": "132",
  F2A3DEF679: "133",
  "52B3DEF6C9": "134",
  "429ADEF6F0": "135",
  "82ACDEF606": "136",
  "22B3DEF6B9": "137",
  "52AADEF6D0": "138",
  F29BDEF641: "139",
  B29CDEF606: "140",
  C2ABDEF641: "141",
  "62BBDEF6F1": "142",
  "02A3DEF689": "143",
  "8299DEF633": "144",
  "929BF621DE": "145",
  C2B9DEF653: "146",
  "1277DEF64D": "147",
  "62A3DEF6E9": "148",
  "12B4DEF68E": "149",
  "52A9DEF6D3": "150",
  "92BBF601DE": "151",
  "92C4F67EDE": "152",
  "22A9DEF6A3": "153",
  F2BBDEF661: "154",
  "5299DEF6E3": "155",
  C296DEF67C: "156",
  E2A2DEF668: "157",
  A2B4DEF63E: "158",
  "5295DEF6EF": "159",
  F2B9DEF663: "160",
  D2B4DEF64E: "161",
  "829CDEF636": "162",
  "52BCDEF6C6": "163",
  "82BCDEF616": "164",
  "22BCDEF6B6": "165",
  "32B9DEF6A3": "166",
  "22BADEF6B0": "167",
  "22A4DEF6AE": "168",
  B2BADEF620: "169",
  "62C4DEF68E": "170",
  C2BBDEF651: "171",
  "92ABF611DE": "172",
  "0270DBF65F": "173", //new
  F294DEF64E: "174",
  "72A1DEF6FB": "175",
  "6278DEF632": "176",
  "32BBDEF6A1": "177",
  "02BBDEF691": "178",
  "02B2DEF698": "179",
  "329BDEF681": "180",
  "8295DEF63F": "181",
  "22AADEF6A0": "182",
  E276DEF6BC: "183",
  "2299DEF693": "184",
  A29ADEF610: "185",
  C2A9DEF643: "186",
  D27EDEF684: "187",
  C2C4DEF62E: "188",
  B276DEF6EC: "189",
  "0278DEF652": "190",
  C294DEF67E: "191",
  "8276DEF6DC": "192",
  C2B2DEF658: "193",
  F2A9DEF673: "194",
  "3278DEF662": "195",
  "729ADEF6C0": "196", //new
  "42B4DEF6DE": "197",
  B2A4DEF63E: "198",
  "22ACDEF6A6": "199",
  "129BDEF6A1": "200",
  "32A3DEF6B9": "201",
  "529CDEF6E6": "202",
  D295DEF66F: "203",
  E2ACDEF666: "204",
  "72B4DEF6EE": "205",
  "02ABDEF681": "206",
  C2A3DEF649: "207",
  F2ABDEF671: "208",
  E2BADEF670: "209",
  A26FDEF6E5: "210",
  "6270DEF63A": "211",
  "92B9F603DE": "212",
  E26EDEF6A4: "213",
  "92B2F608DE": "214",
  C26EDEF684: "215",
  B295DEF60F: "216",
  F2A1DEF67B: "217",
  "027FDEF655": "218",
  "129ADEF6A0": "219",
  "927FF6C5DE": "220",
  "327FDEF665": "221",
  "12A1DEF69B": "222",
  B2A2DEF638: "223",
  "82BADEF610": "224",
  "12B1DEF68B": "225",
  "426FDEF605": "226",
  B2B3DEF629: "227",
  "9296F62CDE": "228",
  B299DEF603: "229",
  "629BDEF6D1": "230",
  A27EDEF6F4: "231",
  "4277DEF61D": "232",
  "3270DEF66A": "233",
  "726FDEF635": "234",
  A277DEF6FD: "235",
  B2AADEF630: "236",
  D2B1DEF64B: "237", // new
  "52BADEF6C0": "238",
  A2B1DEF63B: "239",
  "22A2DEF6A8": "240",
  E2AADEF660: "241",
  "9268F6D2DE": "242",
  "0270DEF65A": "243",
  "32B2DEF6A8": "244",
  "7277DEF62D": "245",
  "126FDEF655": "246",
  "62C2DEF688": "247",
  "02B9DEF693": "248",
  "627FDEF635": "249",
  "82A9DEF603": "250",
  "92C2F678DE": "251",
  C2C2DEF628: "252",
  "62B9DEF6F3": "253",
  D26FDEF695: "254",
  "0296DEF6BC": "255",
  "82A2DEF608": "256",
  "6296DEF6DC": "257",
  "52A2DEF6D8": "258",
  "42B1DEF6DB": "259",
  "72B1DEF6EB": "260",
  "82AADEF600": "261",
  "92A1F61BDE": "262",
  "42A1DEF6CB": "263",
  "6268DEF622": "264",
  "3268DEF672": "265",
  D277DEF68D: "266",
  F2B2DEF668: "267",
  E299DEF653: "268",
  C2A1DEF64B: "269",
  C29ADEF670: "270",
};
const cartridgeMapRev = {
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  10: "10",
  11: "11",
  12: "12",
  13: "13",
  14: "14",
  15: "15",
  16: "16",
  17: "17",
  18: "18",
  19: "19",
  20: "20",
};

const cartridgeOptions = [
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
  "21",
  "22",
  "23",
  "24",
  "25",
  "26",
  "27",
  "28",
  "29",
  "30",
  "31",
  "32",
  "33",
  "34",
  "35",
  "36",
  "37",
  "38",
  "39",
  "40",
  "41",
  "42",
  "43",
  "44",
  "45",
  "46",
  "47",
  "48",
  "49",
  "50",
  "51",
  "52",
  "53",
  "54",
  "55",
  "56",
  "57",
  "58",
  "59",
  "60",
  "61",
  "62",
  "63",
  "64",
  "65",
  "66",
  "67",
  "68",
  "69",
  "70",
  "71",
  "72",
  "73",
  "74",
  "75",
  "76",
  "77",
  "78",
  "79",
  "80",
  "81",
  "82",
  "83",
  "84",
  "85",
  "86",
  "87",
  "88",
  "89",
  "90",
  "91",
  "92",
  "93",
  "94",
  "95",
  "96",
  "97",
  "98",
  "99",
  "100",
  "101",
  "102",
  "103",
  "104",
  "105",
  "106",
  "107",
  "108",
  "109",
  "110",
  "111",
  "112",
  "113",
  "114",
  "115",
  "116",
  "117",
  "118",
  "119",
  "120",
  "121",
  "122",
  "123",
  "124",
  "125",
  "126",
  "127",
  "128",
  "129",
  "130",
  "131",
  "132",
  "133",
  "134",
  "135",
  "136",
  "137",
  "138",
  "139",
  "140",
  "141",
  "142",
  "143",
  "144",
  "145",
  "146",
  "147",
  "148",
  "149",
  "150",
  "151",
  "152",
  "153",
  "154",
  "155",
  "156",
  "157",
  "158",
  "159",
  "160",
  "161",
  "162",
  "163",
  "164",
  "165",
  "166",
  "167",
  "168",
  "169",
  "170",
  "171",
  "172",
  "173",
  "174",
  "175",
  "176",
  "177",
  "178",
  "179",
  "180",
  "181",
  "182",
  "183",
  "184",
  "185",
  "186",
  "187",
  "188",
  "189",
  "190",
  "191",
  "192",
  "193",
  "194",
  "195",
  "196",
  "197",
  "198",
  "199",
  "200",
  "201",
  "202",
  "203",
  "204",
  "205",
  "206",
  "207",
  "208",
  "209",
  "210",
  "211",
  "212",
  "213",
  "214",
  "215",
  "216",
  "217",
  "218",
  "219",
  "220",
  "221",
  "222",
  "223",
  "224",
  "225",
  "226",
  "227",
  "228",
  "229",
  "230",
  "231",
  "232",
  "233",
  "234",
  "235",
  "236",
  "237",
  "238",
  "239",
  "240",
  "241",
  "242",
  "243",
  "244",
  "245",
  "246",
  "247",
  "248",
  "249",
  "250",
  "251",
  "252",
  "253",
  "254",
  "255",
  "256",
  "257",
  "258",
  "259",
  "260",
  "261",
  "262",
  "263",
  "264",
  "265",
  "266",
  "267",
  "268",
  "269",
  "270",
];

class UnwrappedDoseInformation extends Component {
  constructor(props) {
    super(props);
    this.state = { rfid: false };
  }
  componentDidMount() {
    const { data } = this.props;
    const { cartridge_id } = data;
    if (cartridge_id !== null && cartridge_id !== "" && cartridge_id) {
      this.setState({ rfid: cartridge_id.toString().length > 3 });
    }
  }
  handleSubmit = (e) => {
    const { form, handleDoseInfo, changeActiveKey } = this.props;

    e.preventDefault();
    form.validateFields((err, values) => {
      if (err) {
        return;
      }

      delete values.form;
      if (values.cartridge_id == "0") {
        values.cartridge_id = "";
      } else {
        values.cartridge_id = this.state.rfid
          ? cartridgeMapRFID[Number(values.cartridge_id)]
          : cartridgeMap[Number(values.cartridge_id)];
      }
      values.form = values.unit;
      console.log(values);

      handleDoseInfo(values);

      changeActiveKey("2");
    });
  };

  render() {
    const { form, valueForm, selectedMed, data } = this.props;

    /* eslint-disable */
    const { cartridge_id, unit, quantity } = data;

    // const medForm = this.props.valueForm;

    const medName = selectedMed.split("#")[1];

    const { getFieldDecorator, getFieldValue } = form;

    // #########################################################################

    const unitMaps = {
      accuhaler: ["PUFF (MD)"],
      aerosol: ["SPRAY"],
      "aerosol spray": ["SPRAY"],
      autohaler: ["PUFF (MD)"],
      balm: ["APPLICATION (1 FTU)"],
      "bar soap": [""],
      "bath oil": ["APPLICATION (OIL) "],
      "bilayer coated tab": ["TAB"],
      biscuit: ["BISCUIT"],
      cap: ["CAP"],
      "cap (lyo)": ["CAP"],
      caplet: ["CAP"],
      captab: ["TAB"],
      "chewable tab": ["TAB"],
      chewtab: ["TAB"],
      "coated tab": ["TAB"],
      "Combi- kit": ["KIT"],
      "Compliance- kit": ["KIT"],
      "CR cap": ["CAP"],
      "CR tab": ["TAB"],
      cream: ["APPLICATION (1 FTU)"],
      "dental gel": ["APPLICATION (1 FTU)"],
      "dental paste": ["APPLICATION (PASTE)"],
      "dental soln": ["GARGLE"],
      "depot inj": ["UNITS", "ML", "INJ", "G", "MG", "MCG"],
      "dermal patch": ["PATCH"],
      "dispersible cap": ["CAP"],
      dispertab: ["TAB"],
      "DP inhalation powd cap": ["CAP"],
      "DR cap": ["CAP"],
      "DR tab": ["TAB"],
      "DR-FC tab": ["TAB"],
      drag: ["TAB"],
      dressing: ["DRESSING"],
      drink: ["DRINK"],
      "dry syr": ["TBSP"],
      durule: ["DURULE"],
      "DUST- topical powd": [""],
      "ear drops": ["DROP"],
      "EC granules": ["TBSP"],
      "EC-CR cap": ["CAP"],
      "effervescent tab": ["TAB"],
      elixir: ["TBSP"],
      "emulsion for infusion": ["ML"],
      enema: ["ML"],
      "enteric film-coated tab": ["TAB"],
      "enteric-coated cap": ["CAP"],
      "enteric-coated tab": ["TAB"],
      "ER cap": ["CAP"],
      "ER tab": ["TAB"],
      "ER- vag tab": ["TAB"],
      evohaler: ["PUFF (MD)"],
      extentab: ["TAB"],
      "eye drops": ["DROP"],
      "eye gel": ["APPLICATION (1 FTU)"],
      "eye lotion": ["APPLICATION (1 FTU)"],
      "eye oint": ["APPLICATION (1 FTU)"],
      "eye soln": ["DROP"],
      "eye susp": ["DROP"],
      "eye/ear drops": ["DROP"],
      "eye/ear soln": ["DROP"],
      "Face wash- topical gel": ["APPLICATION (1 FTU)"],
      "Face- wash": [""],
      "facial mask": [""],
      "FC- captab": ["TAB"],
      filcotab: ["TAB"],
      film: ["FILM"],
      "film-coated tab": ["TAB"],
      filmtab: ["TAB"],
      FlexPen: ["UNITS", "ML", "INJ", "G", "MG", "MCG"],
      foam: [""],
      gargle: ["GARGLE"],
      "gastro-resistant cap": ["CAP"],
      "gastro-resistant tab": ["TAB"],
      "gelatin-coated tab": ["TAB"],
      "granules for oral susp": ["TBSP"],
      "Hair tinct": [""],
      "Hair- topical oil": ["ML & APPLICATION (OIL)"],
      infusion: ["UNITS", "ML", "INJ", "G", "MG", "MCG"],
      "infusion conc": ["UNITS", "ML", "INJ", "G", "MG", "MCG"],
      inhalant: ["MCG"],
      "inhalation liqd cap": ["CAP"],
      "inhalation powd cap": ["CAP"],
      "inhalation soln": ["PUFF (MD)"],
      inhaler: ["PUFF (MD)"],
      inj: ["UNITS", "ML", "INJ", "G", "MG", "MCG"],
      "inj (lyo) for soln": ["UNITS", "ML", "INJ", "G", "MG", "MCG"],
      "inj (pre-filled)": ["UNITS", "ML", "INJ", "G", "MG", "MCG"],
      "inj conc": ["UNITS", "ML", "INJ", "G", "MG", "MCG"],
      "intra-uterine device": ["IUD"],
      "intraocular inj": ["UNITS", "ML", "INJ", "G", "MG", "MCG"],
      "IR tab": ["TAB"],
      jelly: ["APPLICATION (1 FTU)"],
      kit: ["KIT"],
      linctus: ["TBSP"],
      liniment: ["TSP", "TBSP"],
      "lipid complex inj": ["UNITS", "ML", "INJ", "G", "MG", "MCG"],
      "liposomal inj": ["UNITS", "ML", "INJ", "G", "MG", "MCG"],
      "liqd soap": [""],
      lotion: [""],
      loz: ["LOZ"],
      "MD- modified-release tab": ["TAB"],
      "MD- tab": ["TAB"],
      MDI: ["PUFF (MD)"],
      "MELT- modified-release tab": ["TAB"],
      "MELT- tab": ["TAB"],
      "modified-release cap": ["CAP"],
      "modified-release tab": ["TAB"],
      "mouth paint": ["APPLICATION (1 FTU)"],
      mouthwash: ["GARGLE"],
      "nail lacquer": [""],
      "nasal aerosol": ["SPRAY"],
      "nasal drops": ["DROP"],
      "nasal oint": ["APPLICATION (1 FTU)"],
      "nasal soln": [""],
      "nasal spray": ["SPRAY"],
      "nebuliser soln": ["ML"],
      "Neonate- powd for inj": ["UNITS", "ML", "INJ", "G", "MG", "MCG"],
      Novolet: ["UNITS", "ML", "INJ", "G", "MG", "MCG"],
      oil: ["ML"],
      oint: ["APPLICATION (1 FTU)"],
      "ophth oint": ["APPLICATION (1 FTU)"],
      "ophth soln": ["DROP"],
      "ophth susp": ["ML"],
      OptiPen: ["UNITS", "ML", "INJ", "G", "MG", "MCG"],
      "oral droplets": ["DROP"],
      "oral drops": ["DROP"],
      "oral emulsion": ["TSP", "TBSP"],
      "oral gel": ["APPLICATION (1 FTU)"],
      "oral granules": ["TBSP"],
      "oral liqd": ["TBSP", "ML"],
      "oral soln": ["TBSP"],
      "oral susp": ["TBSP", "ML"],
      "orally disintegrating tab": ["TAB"],
      orapaste: ["APPLICATION (PASTE)"],
      "orodispersible tab": ["TAB"],
      "oromucosal liqd": ["ML"],
      "oromucosal soln": ["APPLICATION FTU LIQUID"],
      "oromucosal spray": ["SPRAY"],
      ovule: ["OVULE"],
      "P- dispertab": ["TAB"],
      "P- dry syr": ["TBSP"],
      "P- elixir": ["TBSP"],
      "P- film-coated tab": ["TAB"],
      "P- inj": ["UNITS", "ML", "INJ", "G", "MG", "MCG"],
      "P- nasal drops": ["DROP"],
      "P- oral drops": ["DROP"],
      "P- oral liqd": ["TBSP"],
      "P- oral susp": ["TSP", "TBSP"],
      "P- powd for inj": ["UNITS", "ML", "INJ", "G", "MG", "MCG"],
      "P- syr": ["TSP", "TBSP", "ML"],
      "P- tab": ["TAB"],
      paint: ["APPLICATION (1 FTU)"],
      paste: ["APPLICATION (PASTE)"],
      pellets: ["PELLET"],
      penfill: ["UNITS", "ML", "INJ", "G", "MG", "MCG"],
      pessary: ["PESSARY"],
      pill: ["PILL"],
      plaster: ["PLASTER"],
      "powd for inhalation soln": ["PUFF (MD)"],
      "powd for inj": ["UNITS", "ML", "INJ", "G", "MG", "MCG"],
      "powd for oral liqd": ["TBSP"],
      "powd for oral soln": ["TBSP", "SCOOP"],
      "powd for oral susp": ["TBSP"],
      "PR tab": ["TAB"],
      "pre-filled inj": ["UNITS", "ML", "INJ", "G", "MG", "MCG"],
      "pre-filled pen": ["UNITS", "ML", "INJ", "G", "MG", "MCG"],
      "pre-filled syringe": ["UNITS", "ML", "INJ", "G", "MG", "MCG"],
      "rectal cream": ["APPLICATION (1 FTU)"],
      "rectal gel": ["APPLICATION (1 FTU)"],
      "rectal oint": ["APPLICATION (1 FTU)"],
      "rectal soln": ["ML"],
      rectocap: ["CAP"],
      "RES- cap": ["CAP"],
      "RESP- inhalation liqd cap": ["CAP"],
      "Respi- cap": ["CAP"],
      "Respi- inhalation powd cap": ["CAP"],
      respules: ["TSP"],
      "retard tab": ["TAB"],
      rotacap: ["ROTACAP"],
      rub: ["APPLICATION (1 FTU)"],
      "scalp application": [""],
      "scalp soln": ["ML"],
      scrub: [""],
      shampoo: ["ML"],
      soap: [""],
      "soft-gelatin cap": ["CAP"],
      softgel: ["CAP"],
      spansule: ["CAP"],
      "SR cap": ["CAP"],
      "SR tab": ["TAB"],
      "SR-FC tab": ["TAB"],
      "sublingual tab": ["TAB"],
      "sugar-coated tab": ["TAB"],
      supp: ["SUPP"],
      "Surgical scrub": [""],
      suscap: ["CAP"],
      "susp for inj": ["UNITS", "ML", "INJ", "G", "MG", "MCG"],
      syr: ["TBSP", "ML", "TSP"],
      tab: ["TAB"],
      toothpaste: ["APPLICATION (PASTE)"],
      "topical application": ["ML"],
      "topical emulsion": [""],
      "topical gel": ["APPLICATION (1 FTU)"],
      "topical liqd": [""],
      "topical oil": ["ML & APPLICATION (OIL)"],
      "topical powd": [""],
      "topical soln": [""],
      "topical spray": ["SPRAY"],
      "TR cap": ["CAP"],
      "TR tab": ["TAB"],
      "transdermal patch": ["PATCH"],
      "Tulle Gras": ["DRESSING"],
      "vaccine (inj)": ["UNITS", "ML", "INJ", "G", "MG", "MCG"],
      "vaccine (oral)": ["VACCINE"],
      "vag cap": ["CAP"],
      "vag cream": ["APPLICATION (1 FTU)"],
      "vag douche": ["DOUCHE"],
      "vag gel": ["APPLICATION (1 FTU)"],
      "vag insert": ["INSERT"],
      "vag soln": ["APPLICATION FTU LIQUID"],
      "vag supp": ["SUPP"],
      "vag tab": ["TAB"],
      wafer: ["WAFER"],
      wash: [""],
      wipe: ["WIPE"],
      "XR tab": ["TAB"],
      "granules for oral soln": ["SACHET"],
    };

    const fromObject = unitMaps[valueForm];
    // console.log(valueForm);
    // console.log(fromObject);

    let unitOptions;
    if (fromObject === undefined) {
      const units = [
        "ML",
        "FTU",
        "DROP",
        "SPRAY",
        "TSP",
        "TBSP",
        "30ML",
        "U",
        "MG",
        "SACHET",
        "SCOOP",
      ];
      unitOptions = units.map((obj) => (
        <Option key={obj} value={obj}>
          {obj}
        </Option>
      ));
    } else if (fromObject.length > 0) {
      unitOptions = fromObject.map((obj) => (
        <Option key={obj} value={obj}>
          {obj}
        </Option>
      ));
    } else {
      const units = [
        "ML",
        "FTU",
        "DROP",
        "SPRAY",
        "TSP",
        "TBSP",
        "30ML",
        "U",
        "MG",
        "SACHET",
        "SCOOP",
      ];
      unitOptions = units.map((obj) => (
        <Option key={obj} value={obj}>
          {obj}
        </Option>
      ));
    }

    // const { rfid } = this.state;
    // let cartridgeIdOption = rfid
    // ? [cartridgeOptions].map((val) => (
    //       <Option key={val} val={val}>
    //         {val}
    //       </Option>
    //     ))
    //   : [cartridgeMapRev].map((val) => (
    //       <Option key={val} val={val}>
    //         {val}
    //       </Option>
    //     ));

    let cartridgeIdOption = cartridgeOptions.map((val) => (
      <Option key={val} val={val}>
        {val}
      </Option>
    ));

    return (
      <div style={{ margin: "auto", paddingTop: "5%" }}>
        <h5 style={{ textAlign: "center" }}>{medName}</h5>

        <Form layout="inline" onSubmit={this.handleSubmit}>
          <div
            style={{ height: "300px", overflow: "auto", textAlign: "center" }}
          >
            <Row type="flex" justify="space-around">
              <Col>
                <FormItem label="Unit">
                  {getFieldDecorator("unit", {
                    rules: [
                      {
                        required: true,
                        message: "What's the unit of medicine?",
                      },
                    ],
                    initialValue:
                      unitOptions.length === 1
                        ? unitOptions[0].props.value
                        : unit == null
                        ? ""
                        : unit,
                  })(
                    <Select
                      style={{ width: 150 }}
                      showSearch
                      defaultActiveFirstOption
                      placeholder="Select Unit"
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {unitOptions}
                    </Select>
                  )}
                </FormItem>

                <FormItem label="Dose Quantity">
                  {getFieldDecorator("quantity", {
                    rules: [{ required: true, message: "Quantity of med" }],
                    initialValue: quantity == null ? "" : quantity,
                  })(<Input />)}
                </FormItem>
              </Col>

              <Col span="8">
                <Row type="flex">
                  <Col span={24}>
                    <FormItem label="Cartridge ID">
                      {getFieldDecorator("cartridge_id", {
                        rules: [
                          { required: false, message: "Cartridge id please!" },
                        ],
                        initialValue:
                          cartridge_id == null
                            ? 0
                            : cartridge_id == ""
                            ? 0
                            : cartridge_id.toString().length > 3
                            ? Number(cartridgeMapRevRFID[cartridge_id])
                            : Number(cartridgeMapRev[cartridge_id]),
                      })(
                        <Select
                          style={{ width: 150 }}
                          showSearch
                          defaultActiveFirstOption
                          placeholder="Cartridge Id"
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            option.props.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                        >
                          {cartridgeIdOption}
                          {/* {this.state.rfid
                            ? [cartridgeOptions].map((val) => (
                                <Option key={val} val={val}>
                                  {val}
                                </Option>
                              ))
                            : [cartridgeMapRev].map((val) => (
                                <Option key={val} val={val}>
                                  {val}
                                </Option>
                              ))} */}
                        </Select>
                      )}
                    </FormItem>
                    <FormItem name="RFID" valuePropName="checked" label="RFID">
                      <Switch
                        checked={this.state.rfid}
                        onChange={(checked) => {
                          console.log(checked);
                        }}
                        onClick={() => {
                          this.setState({ rfid: !this.state.rfid });
                        }}
                      />
                    </FormItem>
                  </Col>
                </Row>
                <Row type="flex">
                  {"Cartridge status: "}
                  {cartridge_id == null
                    ? "Cartridge not selected"
                    : cartridge_id == ""
                    ? "Cartridge is blank"
                    : cartridge_id.toString().length <= 3
                    ? "Slot"
                    : "RFID"}
                </Row>
              </Col>
            </Row>

            <Row type="flex" justify="center" style={{ marginTop: "5%" }}>
              <Col>
                <FormItem>
                  <Button type="primary" htmlType="submit">
                    To Next
                  </Button>
                </FormItem>
              </Col>
            </Row>
          </div>
        </Form>
      </div>
    );
  }
}

const DoseInformation = Form.create()(UnwrappedDoseInformation);

export default DoseInformation;



// WEBPACK FOOTER //
// ./src/component/AddingMedToOrder/TabsComponents/DoseInformation.js